
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('search-required', {
  ...required,
  message: 'Please enter a search term'
})

export default {
  components: {
    ValidationObserver, ValidationProvider
  },
  props: ['button'],
  data () {
    return {
      query: null,
      loading: false,
      focused: false
    }
  },
  methods: {
    submitSearch () {
      this.$refs.searchInput.focus()
      this.loading = true
      this.$router.push(`/s/${this.query}`)
    },
    searchInputBlurred () {
      if (!this.loading) {
        this.$refs.searchForm.classList.remove('active')
      }
    },
    searchInputFocused () {
      this.focused = true
    }
  }
}
